<div class="multiline-ellipsis-card {{class}}">
  <div class="text-container" #text="" style="-webkit-line-clamp: {{maxLine}};line-clamp:{{maxLine}};line-height:{{lineHeight}}px;" [ngClass]='{ "truncate-text": truncateText }'>
  <div [innerHTML]="multilineText"></div>
  </div>
</div>